import { gql } from '@apollo/client';

const TICKET_COMMENT_COUNT_QUERY = gql`
  query ticketCommentCount($filter: TicketCommentFilterInput) {
    ticketCommentCount(filter: $filter)
  }
`;

export default TICKET_COMMENT_COUNT_QUERY;
